import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import { ChildApp } from "./child/ChildApp";

/** His surface is loaded only on his screen: a child's machine never fetches it. */
const TutorApp = lazy(() => import("./tutor/TutorApp").then((m) => ({ default: m.TutorApp })));
/** Her survey behind its secret link (D32, D33): its own chunk, its own auth, nothing of /vaikas. */
const SurveyApp = lazy(() => import("./child/survey/SurveyApp").then((m) => ({ default: m.SurveyApp })));

function App() {
  const path = window.location.pathname;
  if (path.startsWith("/apzvalga")) {
    return (
      <Suspense fallback={null}>
        <SurveyApp />
      </Suspense>
    );
  }
  if (path.startsWith("/mokytojas")) {
    return (
      <Suspense fallback={null}>
        <TutorApp />
      </Suspense>
    );
  }
  if (!path.startsWith("/vaikas")) {
    window.history.replaceState(null, "", "/vaikas");
  }
  return <ChildApp />;
}

// No StrictMode: its dev-only double effect would write every mount event
// (a beat, a rung and its rung_left) twice into a real log, and the e2e walks
// the dev server against a real API.
createRoot(document.getElementById("root")!).render(<App />);
